import { defineComponent as _defineComponent } from 'vue'
import { UserRole } from '@/store/modules/userRoles/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
  selected: {
    type: Object,
    default: () => ({})
  },
  roles: {
    type: Array,
    default: () => ([])
  }
},
  emits: ['selected-role-changed'],
  setup(__props, { emit }) {

const props = __props;





function updateSelected(newlyselected: UserRole) {
  emit('selected-role-changed', newlyselected);
}

function listItemClass(name: UserRole) {
  return props.selected && props.selected.id === name.id ? 'user-role-item-selected' : 'user-role-item';
}


return { __sfc: true,props, emit, updateSelected, listItemClass }
}

})